export default __webpack_public_path__ + "static/media/6.2.898d1eb0.mp4";